/* This file is autogenerated, see readme.md for instructions */
import WrenchSvgIcon from '@bloomreach/banana-theme/icons/wrench.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const WrenchIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <WrenchSvgIcon />
    </Icon>
  );
});

WrenchIcon.displayName = 'WrenchIcon';

export default WrenchIcon;
